import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {SaleModel} from '../sale.model';
import {SaleSummaryConverter} from './saleSummary.converter';
import {Injectable} from '@angular/core';
import {SaleProductSummaryConverter} from "../../../modules/product/api/converter/saleProductSummary.converter";

@Injectable({providedIn: 'root'})
export class SaleConverter extends HttpModelConverter<SaleModel> {


    constructor(private saleSummaryConverter: SaleSummaryConverter,
                private p: SaleProductSummaryConverter) {
        super();
    }

    protected createInstance(): SaleModel {
        return new SaleModel();
    }

    protected enrichObject(result: SaleModel, src: SaleModel) {
        result.summary = this.saleSummaryConverter.convert(src.summary);
        result.products = this.p.convertFromArray(src.products);
    }

}
